import { useState } from "react";
import { Dialog } from "@components/Dialog";
import Markdown from "@components/Markdown";
import type { ShopBenefit_BenefitFragment } from "@components/ShopBenefit/__generated__/fragments";
import styles from "./index.module.css";
import type { FC } from "react";

type ShopBenefitProps = {
  benefit: ShopBenefit_BenefitFragment;
  onOpened?: () => void;
};

const ShopBenefit: FC<ShopBenefitProps> = ({ benefit, onOpened }) => {
  const [isOpened, setIsOpened] = useState(false);
  const modalHandlers = {
    open: () => {
      setIsOpened(true);
      onOpened?.();
    },
    close: () => setIsOpened(false),
  };

  return (
    <>
      <div className={styles.popupTokuten} onClick={modalHandlers.open}>
        <span>{benefit.displayText}</span>
      </div>

      <Dialog
        open={isOpened}
        title={benefit.title}
        onClose={modalHandlers.close}
        markdown={true}
      >
        <Markdown text={benefit?.content || ""} />
      </Dialog>
    </>
  );
};

export default ShopBenefit;
